import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import z from 'zod';
import { isSupabaseError, SupabaseCodeError } from '../../../../constants/supabaseErrors';
import type { SubTopicDatabase, SubTopicWithLastActivityWithIdDatabase } from '../../../../types';
import { useUpdateSubTopic } from '../../api/useUpdateSubTopic';

const formSchema = z.object({
  name: z.string().trim().min(1, 'Ce champ est obligatoire'),
});

type FormValues = z.infer<typeof formSchema>;

type Props = {
  onClose: () => void;
  subTopic: SubTopicDatabase | SubTopicWithLastActivityWithIdDatabase;
};

export function useUpdateSubTopicModal(props: Props) {
  const { mutateAsync, isPending } = useUpdateSubTopic();
  const [serverError, setServerError] = useState<string | null>(null);

  const form = useForm<FormValues>({
    mode: 'onChange',
    defaultValues: {
      name: props.subTopic.name ?? '',
    },
    resolver: zodResolver(formSchema),
  });

  async function handleConfirm(data: FormValues) {
    setServerError(null);

    try {
      await mutateAsync({
        id: props.subTopic.id,
        command: {
          name: data.name,
        },
      });

      props.onClose();
    } catch (error: unknown) {
      if (isSupabaseError(error)) {
        setServerError(
          error.code === SupabaseCodeError.UniquenessViolation
            ? 'Un sous-sujet porte déjà ce nom. Choisissez-en un autre.'
            : error.message,
        );
        return;
      }

      setServerError("Le sous-sujet n'a pas pu être renommé. Réessayez dans un instant.");
    }
  }

  function handleClose() {
    if (!isPending) {
      props.onClose();
    }
  }

  return {
    form,
    isPending,
    serverError,
    onSubmit: form.handleSubmit(handleConfirm),
    handleClose,
  };
}
